import { render, staticRenderFns } from "./captchaView.vue?vue&type=template&id=3bdf156c&scoped=true"
import script from "./captchaView.vue?vue&type=script&lang=js"
export * from "./captchaView.vue?vue&type=script&lang=js"
import style0 from "./captchaView.vue?vue&type=style&index=0&id=3bdf156c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdf156c",
  null
  
)

export default component.exports